import { render, staticRenderFns } from "./TermsOfAcceptancePagesContainer.vue?vue&type=template&id=70467fcc&"
import script from "./TermsOfAcceptancePagesContainer.vue?vue&type=script&lang=js&"
export * from "./TermsOfAcceptancePagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports